import ColorPickerComponent, { ColorPicker } from './ColorPicker';

export { ColorPicker };
export default ColorPickerComponent;
